module.exports = __webpack_public_path__ + "static/media/google-play.ac1ce91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google-play.png
// module id = 3702
// module chunks = 0